import { render } from "./FileUploadeForm.vue?vue&type=template&id=25798a29&scoped=true"
import script from "./FileUploadeForm.vue?vue&type=script&lang=js"
export * from "./FileUploadeForm.vue?vue&type=script&lang=js"

import "./FileUploadeForm.vue?vue&type=style&index=0&id=25798a29&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-25798a29"

export default script